import {Link} from 'react-router-dom';

import {Badge} from '@common-web/components/ui/badge';
import {Button} from '@common-web/components/ui/button';

import {ArrowRight, Inbox} from 'lucide-react';

import {READY_FOR_CBS_STATUSES} from '@common-web/components/rfc/RfcSubmissionsList';
import {trpc} from '@common-web/lib/trpc';

export interface CbsQueueWidgetProps {
  viewAllHref?: string;
}

/**
 * Compact banner showing the count of RFCs awaiting CBS handoff.
 * Visible only to INTERNAL_ADMIN_RFC users; rendered inline within the
 * submissions list between the header and the filters.
 */
export function CbsQueueWidget({viewAllHref = '/rfc/cbs-queue'}: CbsQueueWidgetProps) {
  const query = trpc.clients.rfc.listForAdmin.useQuery({
    page: 1,
    limit: 1,
    sortKey: 'createdAt',
    sortDirection: 'asc',
    statuses: READY_FOR_CBS_STATUSES,
  });

  const total = query.data?.pagination.total ?? 0;

  if (query.isLoading || total === 0) return null;

  return (
    <div className='flex items-center justify-between gap-3 rounded-lg border border-purple-200 bg-purple-50 px-4 py-2.5 mb-4'>
      <div className='flex items-center gap-2.5'>
        <Inbox className='h-4 w-4 text-purple-700' />
        <span className='text-sm font-medium text-brand-navy'>CBS Queue</span>
        <Badge variant='secondary' className='bg-purple-100 text-purple-900 text-xs'>
          {total}
        </Badge>
        <span className='text-xs text-brand-gray'>
          deal{total !== 1 ? 's' : ''} awaiting group creation
        </span>
      </div>
      <Button variant='ghost' size='sm' className='h-7 text-xs text-purple-700' asChild>
        <Link to={viewAllHref} className='flex items-center gap-1'>
          View queue
          <ArrowRight className='h-3 w-3' />
        </Link>
      </Button>
    </div>
  );
}
